export default __webpack_public_path__ + "static/media/duskbreakerslogo.668e87ed.svg";